import { Injectable } from '@angular/core';
import { ErrorTypes } from '../enums/errorTypes.enum';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { ErrorMessage } from '../models/errorMessage.model';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  errorThrown = false;
  errorMessage$ = new BehaviorSubject<ErrorMessage>(new ErrorMessage(ErrorTypes.Generic));

  constructor(private router: Router) {}

  throwError(errorType: ErrorTypes = ErrorTypes.Generic, message?: string) {
    this.errorThrown = true;
    this.errorMessage$.next(new ErrorMessage(errorType, message));
    this.router.navigate(['/error'], { queryParamsHandling: 'merge' });
  }
}
